import { Title } from '@app/components/core/typography/Title'
import Column from '@app/components/layout/Column'
import { useAuthState, useClient } from '@based/sdk/react'
import { i18n } from '@i18n/index'
import { useLanguage } from '@i18n/useLanguage'
import { useEffect, useState } from 'react'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { useLocation } from 'wouter'
import { pages } from '@app/util/links'
import { Button } from '@app/components/core/button/Button'
import { DashboardListCard } from '@app/components/blocks/card/DashboardListCard'
import { INITIATIVE_USER_ROLES } from '@schema/initiative'
import { DashboardListPlotModel } from 'functions/app/dashboard/profile/plot/list'
import { labelAddressBuilder } from '@app/util/helpers'

export const FollowedPlots = () => {
  const [language, _setLanguage] = useLanguage()
  const translations = i18n.languages[language].app.dashboard.followed
  const commonTranslations = i18n.languages[language].app.common
  const client = useClient()
  const authState = useAuthState()
  const [followedPlots, setFollowedPlots] = useState<DashboardListPlotModel[]>(
    [],
  )
  const [_, navigate] = useLocation()

  useEffect(() => {
    if (!authState.userId) {
      return
    }
    const close = client
      .query('list-user-plot', {
        userId: authState.userId,
        role: INITIATIVE_USER_ROLES.follower,
      })
      .subscribe((plots) => {
        setFollowedPlots(plots)
      })
    return () => close()
  }, [client, authState.userId])

  if (followedPlots.length === 0) {
    return null
  }

  const unfollow = async (plotId: number) => {
    await client.call('follow-plot', {
      plotId: plotId,
    })
  }

  return (
    <>
      <Title.H4>{translations.plots}</Title.H4>
      <Column alignItems="stretch">
        {followedPlots.map((plot) => (
          <DashboardListCard
            key={plot.slug}
            title={plot.name}
            subtitle={plot.description}
            image={plot.media?.[0]?.src ?? defaultProjectPicture}
            location={labelAddressBuilder(
              plot.location.address,
              commonTranslations.notSpecified,
            )}
            onClick={() => navigate(pages.plot(plot.slug))}
            action={
              <Button
                variant="secondary"
                size="small"
                label={translations.unfollow}
                onClick={(e) => {
                  e.stopPropagation()
                  void unfollow(plot.id)
                }}
              />
            }
          />
        ))}
      </Column>
    </>
  )
}
